import { routeHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CookiePolicy from "@/pages/CookiePolicy";

export const Route = createFileRoute("/pl/cookie-policy")({
  head: () => routeHead('Polityka cookies — AGAPE', 'Sprawdź, jak AGAPE używa plików cookies i zarządza Twoimi preferencjami.', '/pl/cookie-policy'),
  component: CookiePolicy,
});
